import { useTranslation } from 'react-i18next';
import { Button, Modal } from '@asset-metrix/portal-ui';
import { Text } from '@mantine/core';

type DashboardUnsavedChangesModalProps = {
  opened: boolean;
  onStay: () => void;
  onDiscard: () => void;
};

export function DashboardUnsavedChangesModal({
  opened,
  onStay,
  onDiscard,
}: DashboardUnsavedChangesModalProps) {
  const { t } = useTranslation();

  return (
    <Modal
      actions={
        <>
          <Button variant="secondary" onClick={onStay}>
            {t('app.dashboard.unsavedChangesModal.stay')}
          </Button>
          <Button onClick={onDiscard}>
            {t('app.dashboard.unsavedChangesModal.discard')}
          </Button>
        </>
      }
      data-testid="dashboard-unsaved-changes-modal"
      modalType="action"
      opened={opened}
      onClose={onStay}
      size={420}
      title={t('app.dashboard.unsavedChangesModal.title')}
      zIndex={400}
    >
      <Text component="p" m={0}>
        {t('app.dashboard.unsavedChangesModal.message')}
      </Text>
    </Modal>
  );
}
